export default __webpack_public_path__ + "static/media/404.afab68aa.png";